import { createSelector, Store } from '@ngrx/store';
import { selectShared } from './shared.selectors';
import { inject } from '@angular/core';
import { AppState } from '../models';
import { toSignal } from '@angular/core/rxjs-interop';

export const currentUser = createSelector(selectShared, (state) => state.currentUser);

export function injectCurrentUser() {
  const store = inject<Store<AppState>>(Store<AppState>);
  return toSignal(store.select(currentUser));
}

export const currentUserSettings = createSelector(selectShared, (state) => state.userSettings);
